import { render, staticRenderFns } from "./KeytypeChart.vue?vue&type=template&id=6f10e969&scoped=true"
import script from "./KeytypeChart.vue?vue&type=script&lang=js"
export * from "./KeytypeChart.vue?vue&type=script&lang=js"
import style0 from "./KeytypeChart.vue?vue&type=style&index=0&id=6f10e969&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f10e969",
  null
  
)

export default component.exports